import { globalInfo } from "../../env/util"
import { OverlayCoreDSL } from "./overlayCore"
import { overlayManager } from "./overlayManager"

export class Overlay extends OverlayCoreDSL {
  // 定时器
  private _timer

  // 展示浮层
  public showOverlay(data: any) {
    const overlayConfigs = globalInfo.get('overlayConfigs') || []
    const overlayConfig = overlayConfigs.find(o => o.name === this.defaultName)
    if (!overlayConfig) {
      throw new Error("not find overlay resource")
    }
    const { id, duration } = overlayConfig
    if (duration) {
      // 清除定时器
      if (this._timer !== null) {
        clearTimeout(this._timer)
      }
      // 延时关闭浮层
      this._timer = setTimeout(() => {
        // 隐藏overlay
        overlayManager.hide(id)
      }, duration * 1000)

    }

    // 展示overlay
    overlayManager.show(id, data)
  };

  // 隐藏浮层
  public hideOverlay() {
    // 清除定时器
    if (this._timer !== null) {
      clearTimeout(this._timer)
    }
    const overlayConfigs = globalInfo.get('overlayConfigs') || []
    const overlayConfig = overlayConfigs.find(o => o.name === this.defaultName)
    if (!overlayConfig) {
      throw new Error("not find overlay resource")
    }
    const { id } = overlayConfig
    // 隐藏overlay
    overlayManager.hide(id)
  }
}